import { render, staticRenderFns } from "./changePwdDialog.vue?vue&type=template&id=9cd3ac06&scoped=true&"
import script from "./changePwdDialog.vue?vue&type=script&lang=js&"
export * from "./changePwdDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd3ac06",
  null
  
)

export default component.exports